<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>偷配置</span>
          <clear-cache-apply v-if="activeName==='SpecialSteal'" :url="'/config/common-config/index'" />
          <clear-cache-apply v-else />
          <sync-data />
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="偷结果权重" name="stealRetWeight">
            <el-table size="mini" :data="formData.stealRetWeight" border style="width: 70%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="等级范围">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.slv" style="width: 45%" placeholder="最小值" />
                  <span style="padding:0px 7px;">-</span>
                  <el-input v-model.number="row.elv" style="width: 45%" placeholder="最大值" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="权重a">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.weight.a" placeholder="权重a" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="权重b">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.weight.b" placeholder="权重b" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="权重c">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.weight.c" placeholder="权重c" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template v-slot:default="{row,$index}">
                  <el-button v-permisaction="['config:ret-config:del']" size="mini" type="danger" @click="del('stealRetWeight',$index , row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="add('stealRetWeight')">+</el-button>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="save('stealRetWeight')">保存</el-button>
          </el-tab-pane>
          <el-tab-pane label="超级偷" name="superStealWeight">
            <el-table size="mini" :data="formData.superStealWeight" border style="width: 55%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="倍率">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.bet" placeholder="倍率" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="权重">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.v" placeholder="权重" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template v-slot:default="{row,$index}">
                  <el-button v-permisaction="['config:ret-config:del']" size="mini" type="danger" @click="del('superStealWeight',$index , row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="add('superStealWeight')">+</el-button>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="save('superStealWeight')">保存</el-button>
          </el-tab-pane>
          <el-tab-pane label="宝箱权重分配" name="boxRetWeight">
            <el-table size="mini" :data="formData.boxRetWeight" border style="width: 70%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="权重a">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.weight.a" placeholder="权重a" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="权重b">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.weight.b" placeholder="权重b" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="权重c">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.weight.c" placeholder="权重c" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="显示宝箱概率">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.weight.d" placeholder="显示宝箱概率" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template v-slot:default="{row,$index}">
                  <el-button v-permisaction="['config:ret-config:del']" size="mini" type="danger" @click="del('boxRetWeight',$index , row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="add('boxRetWeight')">+</el-button>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="save('boxRetWeight')">保存</el-button>
          </el-tab-pane>
          <el-tab-pane label="偷权重修正系数" name="betRetWeight">
            <el-table size="mini" :data="formData.betRetWeight" border style="width: 70%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="倍率">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.bet" placeholder="倍率" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="系数a">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.coefficient.a" placeholder="系数a" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="系数b">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.coefficient.b" placeholder="系数b" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="系数c">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.coefficient.c" placeholder="系数c" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template v-slot:default="{row,$index}">
                  <el-button v-permisaction="['config:ret-config:del']" size="mini" type="danger" @click="del('betRetWeight',$index , row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="add('betRetWeight')">+</el-button>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="save('betRetWeight')">保存</el-button>
          </el-tab-pane>
          <el-tab-pane label="宝箱权重修正系数" name="betBoxRetWeight">
            <el-table size="mini" :data="formData.betBoxRetWeight" border style="width: 70%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="倍率">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.bet" placeholder="倍率" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="系数a">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.coefficient.a" placeholder="系数a" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="系数b">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.coefficient.b" placeholder="系数b" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="系数c">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.coefficient.c" placeholder="系数c" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="显示宝箱系数">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.coefficient.d" placeholder="显示宝箱系数" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template v-slot:default="{row,$index}">
                  <el-button v-permisaction="['config:ret-config:del']" size="mini" type="danger" @click="del('betBoxRetWeight',$index , row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="add('betBoxRetWeight')">+</el-button>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="save('betBoxRetWeight')">保存</el-button>
          </el-tab-pane>
          <el-tab-pane label="偷袭最大金额" name="stealMaxMoney">
            <el-row :gutter="10" class="mb8">
              <el-col :span="1.5">
                <el-upload ref="upload" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="(res)=>{return importProbUploadSuccess(res)}" :headers="headers">
                  <el-button v-permisaction="['config:stealMaxMoney:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>

              <el-col :span="1.5">
                <el-button v-permisaction="['config:stealMaxMoney:export']" type="primary" icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
              </el-col>
            </el-row>
            <el-table size="mini" :data="stealMaxMoney" border style="width: 70%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="倍率">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.level" placeholder="倍率" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大金额">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.value" placeholder="最大金额" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template v-slot:default="{row}">
                  <el-button size="mini" type="danger" @click="delStealMax(row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button v-permisaction="['config:stealMaxMoney:add']" size="mini" type="primary" @click="addStealMax()">+</el-button>
            <el-button v-permisaction="['config:stealMaxMoney:add']" size="mini" type="primary" @click="saveStealMax">保存</el-button>
            <pagination v-show="total>0" background :page.sync="queryParams.pageIndex" :limit.sync="queryParams.pageSize" :total="total" @pagination="getStealMax" />
          </el-tab-pane>
          <el-tab-pane label="偷金币比列配置" name="STEAL_RATIC_PRO_CFG">
            <el-row :gutter="10" class="mb8">
              <el-col :span="1.5">
                <el-upload ref="upload1" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="(res)=>{return importStealRaticUploadSuccess(res)}" :headers="headers">
                  <el-button v-permisaction="['config:StealRatic:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>

              <el-col :span="1.5">
                <el-button v-permisaction="['config:StealRatic:export']" type="primary" icon="el-icon-download" size="mini" @click="exportStealRaticData()">导出</el-button>
              </el-col>
            </el-row>
            <el-table size="mini" :data="formData.STEAL_RATIC_PRO_CFG" border style="width: 70%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="等级ID">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.id" readonly placeholder="等级ID" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="金额">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.bet" placeholder="金额" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="好友权重">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.f_weight" placeholder="好友权重" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="权重">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.weight" placeholder="权重" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="机器人权重">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.isRobot" placeholder="机器人权重" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template v-slot:default="{row,$index}">
                  <el-button size="mini" type="danger" @click="del('STEAL_RATIC_PRO_CFG', $index, row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="add('STEAL_RATIC_PRO_CFG')">+</el-button>
            <el-button v-permisaction="['config:ret-config:add']" size="mini" type="primary" @click="save('STEAL_RATIC_PRO_CFG')">保存</el-button>
          </el-tab-pane>
          <el-tab-pane label="特殊偷袭" name="SpecialSteal">
            <el-tabs tab-position="left">
              <el-tab-pane label="基础概率配置">
                <el-form ref="form" label-width="120px" style="width: 30%">
                  <el-form-item label="触发概率" label-width="150px">
                    <el-input v-model="specialSteal.triggerPro">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="机器人闲置时长" label-width="150px">
                    <el-input v-model="specialSteal.robotWait">
                      <template slot="append">秒</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="中钱堆范围（比例）" label-width="150px">
                    <el-input v-model.number="specialSteal.moneyRangeMin" size="small" style="display: inline-block" />-
                    <el-input v-model.number="specialSteal.moneyRangeMax" size="small" style="display: inline-block" />
                  </el-form-item>
                  <el-form-item>
                    <el-button size="small" type="primary" @click="onSpecialStealSubmit">保存</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="机器人等待次数">
                <el-button style="margin-bottom: 1vh" size="small" type="primary" @click="onSpecialStealSubmit">保存</el-button>
                <el-table size="small" :data="specialSteal.robotTimes" border style="width: 50%">
                  <el-table-column label="次数">
                    <template v-slot:default="{row}">
                      <el-input v-model.number="row.times" size="small" />
                    </template>
                  </el-table-column>
                  <el-table-column label="权重">
                    <template v-slot:default="{row}">
                      <el-input v-model.number="row.v" size="small" />
                    </template>
                  </el-table-column>
                </el-table>
                <el-button style="margin-top: 1vh" size="small" type="primary" @click="AddRobotTimes">新建</el-button>
                <el-button style="margin-top: 1vh" size="small" type="primary" @click="DecrRobotTimes">删除</el-button>
              </el-tab-pane>
              <el-tab-pane label="棋盘金币比例">
                <el-button style="margin-bottom: 1vh" size="small" type="primary" @click="onSpecialStealSubmit">保存</el-button>
                <el-table size="small" :data="specialSteal.boardMoneyPro" border style="width: 50%">
                  <el-table-column label="位置">
                    <template v-slot:default="{row}">
                      <el-input v-model.number="row.id" size="small" />
                    </template>
                  </el-table-column>
                  <el-table-column label="比列">
                    <template v-slot:default="{row}">
                      <el-input v-model.number="row.pro" size="small" />
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { updateBuildCfgList } from '@/api/config/build-cfg'
import { getSlotWeightChangeCfg, updateSlotWeightChangeCfg } from '@/api/config/slot'
import { importStealMaxCfg } from '@/api/config/activity-coin-cfg'
import { exportStealRatic, getCommonCfg, importStealRatic, updateCommonCfg } from '@/api/config/common-cfg'
import { getToken } from '@/utils/auth'
import {
  delActivityCoinCfg,
  exportStealMaxCfg,
  getStealMaxList,
  updateActivityCoinCfg
} from '@/api/config/activity-coin-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'RetConfig',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      activeName: 'stealRetWeight',
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      commonCfg: ['TIGER_ATTACK_CONFIG', 'stealMaxMoney', 'STEAL_RATIC_PRO_CFG'],
      formData: {
        superStealWeight: [{ bet: 1, v: 1 }],
        stealRetWeight: [{
          slv: 1,
          elv: 5,
          weight: { a: 25, b: 25, c: 25, d: 0 },
          id: 0
        }],
        boxRetWeight: [{
          weight: { a: 25, b: 25, c: 25, d: 0 },
          id: 0
        }],
        betRetWeight: [{
          bet: 1,
          coefficient: { a: 25, b: 25, c: 25, d: 0 },
          id: 0
        }],
        betBoxRetWeight: [{
          bet: 1,
          coefficient: { a: 25, b: 25, c: 25, d: 0 },
          id: 0
        }],
        stealMaxMoney: [{
          levelId: 1,
          maxCoin: 0
        }],
        STEAL_RATIC_PRO_CFG: [{
          id: 1,
          bet: 0,
          f_weight: 0,
          weight: 0,
          isRobot: 0
        }]
      },
      stealMaxMoney: [
        { id: 0, type: 'stealMaxMoney', level: 1, value: 1 }
      ],
      defaultBoardMoneyPro: [],
      specialSteal: {
        robotWait: 5,
        moneyRangeMin: 5,
        moneyRangeMax: 10,
        robotTimes: [],
        triggerPro: 1,
        boardMoneyPro: []
      }
    }
  },
  created() {
    this.getTables('stealRetWeight')
    this.getStealMax()
    for (let i = 1; i <= 40; i++) {
      this.defaultBoardMoneyPro.push({ id: i, pro: 0 })
    }
    this.handlerSpecialSteal()
  },
  methods: {
    add(name) {
      switch (name) {
        case 'superStealWeight':
          this.formData[name].push({
            bet: 1,
            v: 1
          })
          break
        case 'stealRetWeight':
          this.formData[name].push({
            slv: 0,
            elv: 1,
            weight: { a: 0, b: 0, c: 0, d: 0 },
            id: 0
          })
          break

        case 'boxRetWeight':
          this.formData[name].push({
            weight: { a: 0, b: 0, c: 0, d: 0 },
            id: 0
          })
          break

        case 'betRetWeight':
        case 'betBoxRetWeight':
          this.formData[name].push({
            bet: 0,
            coefficient: { a: 0, b: 0, c: 0, d: 0 },
            id: 0
          })
          break

        case 'stealMaxMoney':
          // eslint-disable-next-line no-case-declarations
          const i = this.formData[name].length
          this.formData[name].push({
            levelId: i + 1,
            maxCoin: 0
          })
          break

        case 'STEAL_RATIC_PRO_CFG':
          // eslint-disable-next-line no-case-declarations
          const i1 = this.formData[name].length
          this.formData[name].push({
            id: i1 + 1,
            bet: 0,
            f_weight: 0,
            weight: 0,
            isRobot: 0
          })
          break
      }
    },
    save(name) {
      let data = JSON.stringify(this.formData[name])
      if (name === 'STEAL_RATIC_PRO_CFG') {
        const _data = this.formData[name]
        for (const i in _data) {
          _data[i].bet = parseFloat(_data[i].bet)
        }
        data = JSON.stringify(_data)
      }

      let method = updateSlotWeightChangeCfg
      if (this.commonCfg.includes(name)) {
        method = updateCommonCfg
      }
      method({ name: name, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(name)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(name, index, id) {
      this.formData[name] = this.formData[name].filter((item, key) => {
        return index !== key
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateBuildCfgList({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(name) {
      console.log('name', name)
      let method = getSlotWeightChangeCfg
      if (this.commonCfg.includes(name)) {
        method = getCommonCfg
      }
      method({ name: name }).then(res => {
        if (res.code === 200) {
          this.formData[name] = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getStealMax() {
      getStealMaxList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.stealMaxMoney = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    delStealMax(id) {
      delActivityCoinCfg({ id: id }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getStealMax()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addStealMax() {
      const level = this.stealMaxMoney.length + 1
      this.stealMaxMoney.push({ id: 0, type: 'stealMaxMoney', level: level, value: 0 })
    },
    saveStealMax() {
      const _formData = []
      for (const k in this.stealMaxMoney) {
        const val = this.stealMaxMoney[k]
        _formData.push({ level: val.level, key: 'stealMaxMoney', val: val.value })
      }
      const data = JSON.stringify(_formData)
      updateActivityCoinCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getStealMax()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportStealMaxCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportStealRaticData() {
      exportStealRatic().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importStealRaticUploadSuccess(response, name) {
      this.loading = true
      this.$refs['upload1'].clearFiles()
      importStealRatic({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables('STEAL_RATIC_PRO_CFG')
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response, name) {
      this.loading = true
      this.$refs['upload'].clearFiles()
      importStealMaxCfg({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getStealMax()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClick(tab, event) {
      if (tab.name !== 'SpecialSteal') {
        this.getTables(tab.name)
      }
    },
    handlerSpecialSteal() {
      getCommonCfg({ name: 'specialSteal2' }).then(res => {
        this.specialSteal = res.data
        if (!this.specialSteal.boardMoneyPro) {
          this.specialSteal.boardMoneyPro = this.defaultBoardMoneyPro
        }
        if (!this.specialSteal.robotTimes) {
          this.specialSteal.robotTimes = []
        }
        console.log(this.specialSteal)
      })
    },
    onSpecialStealSubmit() {
      updateCommonCfg({ data: JSON.stringify(this.specialSteal), name: 'specialSteal2' }).then(res => {
        this.msgSuccess(res.msg)
      })
    },
    AddRobotTimes() {
      this.specialSteal.robotTimes.push({ v: 0, times: 1 })
    },
    DecrRobotTimes() {
      this.specialSteal.robotTimes.pop()
    }
  }
}
</script>

<style scoped>
</style>
